export const regulationList = [
  { id: 'CFR_49', name: '49CFR' },
  { id: 'MARTITIME', name: 'IMO' },
  { id: 'AIR', name: 'IATA' },
];

export const transportationModeList = [
  { id: 'GROUND', name: 'Ground', iconName: 'icon-status-road' },
  { id: 'CARGO_AIRCRAFT_ONLY', name: 'Cargo Aircraft Only', iconName: 'icon-status-air' },
  { id: 'PASSENGER_AIRCRAFT_CARGO_AIRCRAFT', name: 'Passenger Aircraft', iconName: 'icon-status-air' },
  { id: 'VESSEL', name: 'Vessel', iconName: 'icon-status-ship' },
];

export const maxDisplayColumn = 9;
